if (!customElements.get('cart-note-trigger')) {
  class CartNoteTrigger extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('alexa:open-cart-note-drawer'));
      });
    }
  }
  customElements.define('cart-note-trigger', CartNoteTrigger);
}
